export default from './MobileCalculationsResult';



// WEBPACK FOOTER //
// ./src/sharedComponents/AffordabilityCalculator/components/MobileCalculationsResult/index.js